import { render } from "./MainAccountComponent.vue?vue&type=template&id=50e3aff9"
import script from "./MainAccountComponent.vue?vue&type=script&lang=js"
export * from "./MainAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__